import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export type SiteMediaKey = "caregiver_photo" | "company_banner" | "company_logo" | "recruiter_photo";
export type SiteMedia = Record<SiteMediaKey, string | null>;

export const SITE_MEDIA_QUERY_KEY = ["site-media", "abonnementen_preview"];
export const SITE_MEDIA_BUCKET = "public-assets";
export const SITE_MEDIA_FOLDER = "abonnementen-preview";

const empty: SiteMedia = { caregiver_photo: null, company_banner: null, company_logo: null, recruiter_photo: null };

export function useSiteMedia() {
  return useQuery({
    queryKey: SITE_MEDIA_QUERY_KEY,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<SiteMedia> => {
      const { data, error } = await (supabase as any)
        .from("site_media_settings")
        .select("caregiver_photo, company_banner, company_logo, recruiter_photo")
        .eq("id", "abonnementen_preview")
        .maybeSingle();
      if (error) throw error;
      return { ...empty, ...(data || {}) };
    },
  });
}

export type ParentCompany = { parent_logo: string | null; parent_url: string | null; parent_text: string | null };
export const PARENT_COMPANY_QUERY_KEY = ["site-media", "parent_company"];
export const PARENT_COMPANY_DEFAULT_TEXT = "Onderdeel van Deer Peter B.V. | Samen op jacht";

export function useParentCompany() {
  return useQuery({
    queryKey: PARENT_COMPANY_QUERY_KEY,
    staleTime: 5 * 60 * 1000,
    queryFn: async (): Promise<ParentCompany> => {
      const { data } = await (supabase as any)
        .from("site_media_settings")
        .select("parent_logo, parent_url, parent_text")
        .eq("id", "abonnementen_preview")
        .maybeSingle();
      return { parent_logo: data?.parent_logo ?? null, parent_url: data?.parent_url ?? null, parent_text: data?.parent_text ?? null };
    },
  });
}
